import { useApp } from '../context/AppContext';
import { deleteTryonApi, downloadTryonApi } from '../api';

export default function ActionSheetOverlay() {
  const {
    showActionSheet, setShowActionSheet, actionSheetId,
    albumItems, setAlbumItems,
    mobile, showToast,
    setCurrentResult, setCurrentScreen,
  } = useApp();

  const item = albumItems.find(i => i.id === actionSheetId);

  function close() { setShowActionSheet(false); }

  function asView() {
    if (!item) return;
    setCurrentResult(item);
    setCurrentScreen('result');
    close();
  }

  async function asDownload() {
    if (!item) return;
    close();
    showToast('Preparing download…');
    try {
      const data = await downloadTryonApi(item.id, mobile);
      if (data) {
        const bytes = Uint8Array.from(atob(data.image_b64), c => c.charCodeAt(0));
        const blob  = new Blob([bytes], { type: data.content_type || 'image/jpeg' });
        const href  = URL.createObjectURL(blob);
        const a     = document.createElement('a');
        const ts    = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
        a.href     = href;
        a.download = `boutiqueaitryon_${ts}.jpg`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(href), 8000);
        showToast('Downloaded! ✓');
        return;
      }
    } catch (e) {}
    if (item.result_url) window.open(item.result_url, '_blank');
  }

  async function asDelete() {
    if (!item || !window.confirm('Remove this look from your album?')) return;
    close();
    try { await deleteTryonApi(item.id, mobile); } catch (e) {}
    setAlbumItems(prev => prev.filter(i => i.id !== item.id));
    showToast('Removed from album');
  }

  return (
    <div className={`as-overlay${showActionSheet ? ' show' : ''}`} onClick={e => { if (e.target === e.currentTarget) close(); }}>
      <div className="as">
        <div className="sheet-grip" />
        <button className="as-i" onClick={asView}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          View Look
        </button>
        <button className="as-i" onClick={asDownload}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Download
        </button>
        <button className="as-i danger" onClick={asDelete}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6M14 11v6"/>
          </svg>
          Remove
        </button>
      </div>
    </div>
  );
}
